// src/components/ActiveVaultPage.jsx
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import useEscapeToGoBack from "../hooks/useEscapeToGoBack";
import "./Renew.css";

const API_URL =
  "https://www.lianfoong.com/api/pawn-transactions/active/report/by-mmyy";

const pad2 = (n) => String(n).padStart(2, "0");
const currentMMYY = () => {
  const d = new Date();
  return `${pad2(d.getMonth() + 1)}${String(d.getFullYear()).slice(-2)}`;
};

const ActiveVaultPage = () => {
  useEscapeToGoBack();
  const navigate = useNavigate();
  const inputRef = useRef(null);

  const [mmyy, setMmyy] = useState(currentMMYY());
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => {
      inputRef.current?.focus();
      inputRef.current?.select?.();
    });
  }, []);

  const onlyDigits = (s) => s.replace(/\D/g, "");
  const normalize = (s) => {
    const d = onlyDigits(s).slice(0, 4);
    return d.length === 3 ? `0${d}` : d; // quick pad if they typed 3 digits like "425"
  };

  const downloadBlob = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", filename);
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(url);
    a.remove();
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const val = normalize(mmyy);

    if (!/^\d{4}$/.test(val)) {
      alert("Please enter MMYY as 4 digits, e.g. 0425");
      return;
    }

    setDownloading(true);
    try {
      const resp = await axios.get(API_URL, {
        params: { mmyy: val },
        responseType: "blob",
        validateStatus: () => true, // we’ll handle 404/text errors
      });

      // Handle NOT FOUND / text error payloads gracefully
      const ct = resp.headers?.["content-type"] || "";
      if (resp.status >= 400 || ct.includes("text/plain")) {
        const msg =
          typeof resp.data?.text === "function"
            ? await resp.data.text()
            : "Failed to generate report.";
        alert(msg || "Failed to generate report.");
        return;
      }

      downloadBlob(resp.data, `active_${val}_report.pdf`);
    } catch (err) {
      console.error(err);
      alert("Error generating report.");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="renew-container">
      <h2 className="title">Active Tickets in Vault</h2>

      <form onSubmit={onSubmit}>
        <div className="form-group">
          <label>MMYY (e.g. 0425)</label>
          <input
            ref={inputRef}
            type="text"
            inputMode="numeric"
            pattern="\d{4}"
            maxLength={4}
            value={mmyy}
            onChange={(e) => setMmyy(onlyDigits(e.target.value).slice(0, 4))}
            onBlur={(e) => setMmyy(normalize(e.target.value))}
            placeholder="MMYY"
            required
          />
        </div>

        <button className="search-btn" type="submit" disabled={downloading}>
          {downloading ? "Generating…" : "Generate PDF"}
        </button>

        <button
          type="button"
          className="next-btn"
          onClick={() => navigate(-1)}
          style={{ marginTop: 10 }}
        >
          Back
        </button>
      </form>
    </div>
  );
};

export default ActiveVaultPage;
